import React, { useState } from 'react';
import { Play, Pause } from 'lucide-react';
import LandingScrollReveal from './LandingScrollReveal';

const MockVideoPlayer = ({ title, poster }) => {
  const [playing, setPlaying] = useState(true);

  return (
    <div className="absolute inset-0 flex flex-col bg-design-black">
      {poster ? (
        <img
          src={poster}
          alt=""
          className="absolute inset-0 h-full w-full object-cover opacity-40"
        />
      ) : (
        <div className="absolute inset-0 gradient-deeptech opacity-60" />
      )}
      <div className="absolute inset-0 bg-design-black/30" />
      {playing ? (
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="flex flex-col items-center gap-4 px-6 text-center">
            <div className="h-16 w-16 rounded-full border-2 border-white/30 border-t-white animate-spin" />
            <p className="font-even-mono text-xs uppercase tracking-[0.25em] text-white/60">
              Демо-видео
            </p>
          </div>
        </div>
      ) : null}
      <div className="relative mt-auto p-4 md:p-5 bg-gradient-to-t from-design-black via-design-black/90 to-transparent">
        <p className="text-sm md:text-base font-medium text-white/90 truncate mb-3">{title}</p>
        <div className="flex items-center gap-3">
          <button
            type="button"
            onClick={() => setPlaying((p) => !p)}
            className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-white/15 ring-1 ring-white/20"
            aria-label={playing ? 'Пауза' : 'Воспроизведение'}
          >
            {playing ? (
              <Pause className="h-4 w-4 text-white" aria-hidden />
            ) : (
              <Play className="ml-0.5 h-4 w-4 fill-white text-white" aria-hidden />
            )}
          </button>
          <div className="flex-1 h-1 rounded-full bg-white/20 overflow-hidden">
            <div
              className={`h-full w-1/3 rounded-full bg-accent ${playing ? 'animate-pulse' : ''}`}
            />
          </div>
          <span className="font-even-mono text-xs text-white/50 shrink-0">0:42</span>
        </div>
        <p className="mt-3 font-even-mono text-[10px] uppercase tracking-widest text-white/40">
          Макет — финальное видео будет добавлено
        </p>
      </div>
    </div>
  );
};

const LandingVideoCase = ({ title, caption, embedUrl, poster, isMock = false, index = 0 }) => {
  const [playing, setPlaying] = useState(false);
  const hasRealEmbed = Boolean(embedUrl) && !isMock;
  const hasPlayable = hasRealEmbed || isMock;
  const showEmbed = playing && hasRealEmbed;
  const showMock = playing && isMock;

  return (
    <LandingScrollReveal delay={index * 120} className="w-full">
      <article className="group">
        <div className="relative aspect-video w-full overflow-hidden rounded-2xl md:rounded-3xl bg-design-black ring-1 ring-white/10 shadow-2xl">
          {showEmbed ? (
            <iframe
              title={title}
              src={embedUrl}
              className="absolute inset-0 h-full w-full border-0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          ) : showMock ? (
            <MockVideoPlayer title={title} poster={poster} />
          ) : (
            <>
              {poster ? (
                <img
                  src={poster}
                  alt=""
                  className="absolute inset-0 h-full w-full object-cover opacity-70 transition-transform duration-700 group-hover:scale-[1.02]"
                />
              ) : (
                <div className="absolute inset-0 gradient-deeptech opacity-80" />
              )}
              <div className="absolute inset-0 bg-gradient-to-t from-design-black/90 via-design-black/20 to-transparent" />
              {hasPlayable ? (
                <button
                  type="button"
                  onClick={() => setPlaying(true)}
                  className="absolute inset-0 flex items-center justify-center"
                  aria-label={`Смотреть кейс: ${title}`}
                >
                  <span className="flex h-20 w-20 items-center justify-center rounded-full bg-white/15 backdrop-blur-md ring-1 ring-white/30 transition-transform duration-300 group-hover:scale-110">
                    <Play className="ml-1 h-9 w-9 fill-white text-white" aria-hidden />
                  </span>
                  {isMock ? (
                    <span className="absolute bottom-6 font-even-mono text-[10px] uppercase tracking-widest text-white/50">
                      Демо
                    </span>
                  ) : null}
                </button>
              ) : (
                <div className="absolute inset-0 flex items-center justify-center px-6 text-center">
                  <p className="font-even-mono text-sm uppercase tracking-widest text-white/70">
                    Видеокейс скоро
                  </p>
                </div>
              )}
            </>
          )}
        </div>
        <h3 className="mt-6 text-2xl md:text-3xl font-bold text-foreground">{title}</h3>
        {caption ? (
          <p className="mt-2 max-w-2xl text-lg text-muted-foreground">{caption}</p>
        ) : null}
      </article>
    </LandingScrollReveal>
  );
};

export default LandingVideoCase;
